import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Panel, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import moment from 'moment'
import extract from '../../core/extract'
import {connectWizard} from '../../core/wizard'
import {errorStatus} from '../../core/redux/status'
import {connectForm, selectField, integerField} from '../../core/redux/form'
import Icon from '../../core/components/Icon'
import MeasureInput, {timeUnits} from '../../core/components/MeasureInput'
import {CREATE_WORKFLOW_ACTION_UPDATED, ADD_STEP_ACTION_UPDATED, UPDATE_STEP_ACTION_UPDATED, loadWorkflowStream, sendCreateWorkflowAction, sendAddStepAction, updateAddStepAction, sendUpdateStepAction, resetUpdateStepAction, sendRemoveStepAction} from '../actions'
import {EXPECTED_EVENTS, ACTORS, STEP_TIME_LIMIT_TYPE, CreateWorkflowAction, AddStepAction, UpdateStepAction} from '../models'
import i18n from '../i18n'
import style from './WorkflowPanel.less'

function mapCount(fnc, count) {
    var result = []
    for (var i = 0 ; i < count ; i++) {
        result.push(fnc(i))
    }
    return result
}

function selectActiveStep(steps, {workflow, updateStepAction}) {
    if (!workflow.uid) return 1
    if (workflow.steps.length == 0) return 2.2
    if (updateStepAction) return 2.3
    return 2.1
}

function openingTicketPurposeAggregator(reference) {
    return (result, openingTicketPurposeId) => {
        const openingTicketPurpose = reference.openingTicketPurposes.find((otp) => otp.uid == openingTicketPurposeId)

        if (openingTicketPurpose) {
            result.push(openingTicketPurpose)
        } else {
            console && console.warn('openingTicketPurpose "' + openingTicketPurposeId + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

class WorkflowPanel extends Component {
    static propTypes = {
        workflow: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            identifiedRequests: []
        }
    }

    componentWillMount() {
        const {dispatch, expanded, workflow, reference} = this.props

        if (expanded) {
            const identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), [])
            this.setState({identifiedRequests})

            dispatch(updateAddStepAction({step: {order: workflow.steps.length + 1}}))
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded != this.props.expanded
            || nextProps.workflow != this.props.workflow
            || nextProps.reference != this.props.reference) {

            const {dispatch, expanded, workflow, reference} = nextProps

            if (expanded) {
                const identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), [])
                this.setState({identifiedRequests})

                dispatch(updateAddStepAction({step: {order: workflow.steps.length + 1}}))
            }
        }
    }

    _toggleUpdateStep(step) {
        const {dispatch, updateStepAction} = this.props

        var updateStep = null
        if (step.uid != (updateStepAction && updateStepAction.step.uid)) {
            updateStep = {step}
        }

        return dispatch(resetUpdateStepAction(updateStep))
    }

    _isUpdateStep(step) {
        const {updateStepAction} = this.props
        return step.uid == (updateStepAction && updateStepAction.step.uid)
    }

    _sendCreateWorkflowAction(event) {
        const {dispatch, onSelect} = this.props

        var workflowUid
        return dispatch(sendCreateWorkflowAction()).then((action) => {
            workflowUid = action.workflowUid
            return dispatch(loadWorkflowStream())
        }).then(() => {
            onSelect(event, workflowUid)
        })
    }

    _sendAddStepAction() {
        const {dispatch, workflow, wizard} = this.props

        return dispatch(sendAddStepAction(workflow.uid)).then(() => {
            return dispatch(loadWorkflowStream())
        }).then(() => {
            wizard.setActiveStep(2.1)
        })
    }

    _sendUpdateStepAction() {
        const {dispatch, workflow, wizard} = this.props

        return dispatch(sendUpdateStepAction(workflow.uid)).then(() => {
            return dispatch(loadWorkflowStream())
        }).then(() => {
            wizard.setActiveStep(2.1)
        })
    }

    _sendRemoveStepAction(step) {
        const {dispatch, workflow} = this.props

        return dispatch(sendRemoveStepAction(workflow.uid, step.uid)).then(() => {
            return dispatch(loadWorkflowStream())
        })
    }

    render() {
        const {dispatch, createWorkflowForm, addStepForm, updateStepForm, createWorkflowAction, addStepAction, updateStepAction, reference, workflow, wizard, onSubmit, ...others} = this.props
        const {identifiedRequests} = this.state

        const header = () => {
            if (wizard.matchActiveStep(2)) {
                return (<h5>{workflow.label} ({workflow.steps.length})</h5>)
            }
        }

        const identifiedRequestElement = (identifiedRequest) => (
            <li
                key={identifiedRequest.uid}>
                {identifiedRequest.label}
            </li>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        return (
            <Panel
                header={header()}
                {...others}>
                {wizard.matchActiveStep(1) && (
                    <div className={style.workflowLabel}>
                        <h4>{i18n.workflowLabel}</h4>
                        <form className='form-inline'>
                            <Input
                                type='text'
                                name='name'
                                {...createWorkflowForm.label()} />
                        </form>
                        <h5>{i18n.openTicket}</h5>
                        <Icon icon='arrow' size='sm' />
                        <ButtonToolbar>
                            <Button
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !createWorkflowForm.isValid()})}
                                onClick={(e) => createWorkflowForm.validate() && this._sendCreateWorkflowAction(e) || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.fillStep}
                            </Button>
                        </ButtonToolbar>
                    </div>
                )}
                {wizard.matchActiveStep(2) && (
                    <div className={style.workflowAction}>
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.update)}>
                            <Button
                                href=''
                                bsStyle='link'
                                onClick={(e) => onSubmit(e, 'UpdateWorkflowLabel', workflow)}>
                                <Icon icon='pencil' size='xs' />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.delete)}>
                            <Button
                                href=''
                                bsStyle='link'
                                onClick={(e) => onSubmit(e, 'RemoveWorkflow', workflow)}>
                                <Icon active icon='cross' size='xs' />
                            </Button>
                        </OverlayTrigger>
                    </div>
                )}
                {wizard.matchActiveStep(2) && (
                    <div className={style.stepGroup}>
                        <h5>{i18n.openTicket}</h5>
                        <ul>
                            {workflow.steps.sort((a, b) => a.order - b.order).map((step) => (
                                <li key={step.uid}>
                                    <div className={style.step}>
                                        <strong />
                                    </div>
                                    <div className={style.action}>
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(i18n.update)}>
                                            <Button
                                                bsStyle='link'
                                                active={this._isUpdateStep(step)}
                                                onClick={() => this._toggleUpdateStep(step)}>
                                                <Icon icon='gear' size='xs' />
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(i18n.delete)}>
                                            <Button active
                                                bsStyle='link'
                                                onClick={() => this._sendRemoveStepAction(step)}>
                                                <Icon icon='cross' size='xs' />
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                    <div className={style.container}>
                                        <p>{extract(i18n.expectedEventEnum, step.expectedEvent)}</p>
                                        <p>{step.actors.map((a) => extract(i18n.actorEnum, a)).join(' : ')}</p>
                                        {step.timeLimit && (
                                            <p>{extract(i18n.stepTimeLimitTypeEnum, step.timeLimit.workflowStepTimeLimitType)} - {moment.duration(step.timeLimit.duration).humanize()}</p>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {wizard.matchActiveStep(2.1) && (
                    <ButtonToolbar>
                        <Button
                            bsStyle='primary'
                            bsSize='large'
                            onClick={() => wizard.setActiveStep(2.2)}>
                            {i18n.newStep}
                        </Button>
                    </ButtonToolbar>
                )}
                {wizard.matchActiveStep(2.2) && (
                    <div className={style.newStep}>
                        <form>
                            <Row>
                                <Col xs={8}>
                                    <Input
                                        type='select'
                                        name='expectedEvent'
                                        {...addStepForm.step.expectedEvent()}>
                                        <option value=''>{i18n.expectedEvent} ...</option>
                                        {EXPECTED_EVENTS.map((event) => (
                                            <option
                                                key={event}
                                                value={event}>
                                                {extract(i18n.expectedEventEnum, event)}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col xs={4}>
                                    <Input
                                        type='select'
                                        name='order'
                                        {...integerField(addStepForm.step.order())}>
                                        {mapCount((index) => (
                                            <option
                                                key={index}
                                                value={index + 1}>
                                                {index + 1}
                                            </option>
                                        ), workflow.steps.length + 1)}
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs ={12}>
                                    <Input multiple
                                        type='select'
                                        name='actors'
                                        {...selectField(addStepForm.step.actors(), true)}>
                                        {ACTORS.map((actor) => (
                                            <option
                                                key={actor}
                                                value={actor}>
                                                {extract(i18n.actorEnum, actor)}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={8}>
                                    <Input
                                        type='select'
                                        name='workflowStepTimeLimitType'
                                        {...addStepForm.step.timeLimit.workflowStepTimeLimitType()}>
                                        <option value=''>{i18n.stepTimeLimitType} ...</option>
                                        {STEP_TIME_LIMIT_TYPE.map((type) => (
                                            <option
                                                key={type}
                                                value={type}>
                                                {extract(i18n.stepTimeLimitTypeEnum, type)}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <MeasureInput
                                        name='duration'
                                        units={timeUnits}
                                        placeholder={i18n.duration + ' ...'}
                                        {...addStepForm.step.timeLimit.duration()}/>
                                </Col>
                            </Row>
                        </form>
                        <ButtonToolbar>
                            <Button
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !addStepForm.isValid()})}
                                onClick={() => addStepForm.validate() && this._sendAddStepAction() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.saveStep}
                            </Button>
                            <Button
                                bsSize='large'
                                onClick={() => wizard.setActiveStep(2.1)}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </div>
                )}
                {wizard.matchActiveStep(2.3) && (
                    <div className={style.newStep}>
                        <form>
                            <Row>
                                <Col xs={8}>
                                    <Input disabled
                                        type='text'
                                        name='expectedEvent'
                                        value={extract(i18n.expectedEventEnum, updateStepAction.step.expectedEvent)}>
                                    </Input>
                                </Col>
                                <Col xs={4}>
                                    <Input
                                        type='select'
                                        name='order'
                                        {...integerField(updateStepForm.step.order())}>
                                        {mapCount((index) => (
                                            <option
                                                key={index}
                                                value={index + 1}>
                                                {index + 1}
                                            </option>
                                        ), workflow.steps.length)}
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs ={12}>
                                    <Input multiple
                                        type='select'
                                        name='actors'
                                        {...selectField(updateStepForm.step.actors(), true)}>
                                        {ACTORS.map((actor) => (
                                            <option
                                                key={actor}
                                                value={actor}>
                                                {extract(i18n.actorEnum, actor)}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={8}>
                                    <Input
                                        type='select'
                                        name='workflowStepTimeLimitType'
                                        {...updateStepForm.step.timeLimit.workflowStepTimeLimitType()}>
                                        <option value=''>{i18n.stepTimeLimitType} ...</option>
                                        {STEP_TIME_LIMIT_TYPE.map((type) => (
                                            <option
                                                key={type}
                                                value={type}>
                                                {extract(i18n.stepTimeLimitTypeEnum, type)}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <MeasureInput
                                        name='duration'
                                        units={timeUnits}
                                        placeholder={i18n.duration + ' ...'}
                                        {...updateStepForm.step.timeLimit.duration()}/>
                                </Col>
                            </Row>
                        </form>
                        <ButtonToolbar>
                            <Button
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !updateStepForm.isValid()})}
                                onClick={() => updateStepForm.validate() && this._sendUpdateStepAction() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.updateStep}
                            </Button>
                            <Button
                                bsSize='large'
                                onClick={() => this._toggleUpdateStep(updateStepAction.step)}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </div>
                )}
                {wizard.matchActiveStep(2) && (
                    <div className={style.identifiedRequests}>
                        <div className={style.action}>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={tooltip(i18n.identifiedRequests)}>
                                <Button
                                    href=''
                                    bsStyle='link'
                                    onClick={(e) => onSubmit(e, 'UpdateIdentifiedRequests', workflow)}>
                                    <Icon icon='pencil' size='xs' />
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <Row>
                            <Col sm={6}>
                                <ul>
                                    {identifiedRequests.slice(0, identifiedRequests.length / 2 + 1).map(identifiedRequestElement)}
                                </ul>
                            </Col>
                            <Col sm={6}>
                                <ul>
                                    {identifiedRequests.slice(identifiedRequests.length / 2 + 1, identifiedRequests.length).map(identifiedRequestElement)}
                                </ul>
                            </Col>
                        </Row>
                    </div>
                )}
            </Panel>
        )
    }
}

WorkflowPanel = connectForm({
    name: 'createWorkflowForm',
    target: 'createWorkflowAction',
    alias: 'action',
    schema: CreateWorkflowAction.schema,
    action: CREATE_WORKFLOW_ACTION_UPDATED
})(WorkflowPanel)

WorkflowPanel = connectForm({
    name: 'addStepForm',
    target: 'addStepAction',
    alias: 'action',
    schema: AddStepAction.schema,
    action: ADD_STEP_ACTION_UPDATED
})(WorkflowPanel)

WorkflowPanel = connectForm({
    name: 'updateStepForm',
    target: 'updateStepAction',
    alias: 'action',
    schema: UpdateStepAction.schema,
    action: UPDATE_STEP_ACTION_UPDATED
})(WorkflowPanel)

WorkflowPanel = connectWizard({
    activeStep: selectActiveStep
})(WorkflowPanel)

WorkflowPanel = connect((state) => ({
    reference: state.reference.openingTicketPurposeRef,
    createWorkflowAction: state.workflow.createWorkflowAction,
    updateWorkflowLabelAction: state.workflow.updateWorkflowLabelAction,
    addStepAction: state.workflow.addStepAction,
    updateStepAction: state.workflow.updateStepAction
}))(WorkflowPanel)

export default WorkflowPanel


// WEBPACK FOOTER //
// ./lib/workflow/components/WorkflowPanel.js